import React from 'react';

import { FileImageOutlined, FileGifOutlined, FilePdfOutlined, FileWordOutlined } from '@ant-design/icons';
export const roles = [
    { key: 'CONTROL', title: 'KSC xác nhận' },
    { key: 'CASHIER', title: 'Thu ngân xác nhận' },
    { key: 'ACCEPTANCE', title: 'Tổ nghiệm thu xác nhận' },
];
export const STATUS_TRANSPORT = [
    { key: 0, title: 'Chờ bàn giao', color: 'grey' },
    { key: 1, title: 'KSC xác nhận', color: 'blue' },
    { key: 2, title: 'Thu ngân xác nhận', color: 'green' },
    { key: 3, title: 'Tổ nghiệm thu xác nhận', color: 'orange' },
];

export const checkFileType = (url) => {
    const fileExtension = url.split('.').pop().toLowerCase();
    const fullFileName = url.substring(url.lastIndexOf('/') + 1);
    const content = (
        <a href={url} target="_blank">
            <span style={{ marginLeft: '10px' }}>{fullFileName}</span>
        </a>
    );
    switch (fileExtension) {
        case 'png':
        case 'jpg':
        case 'jpeg':
            return (
                <>
                    <FileImageOutlined />
                    {content}
                </>
            );

        case 'gif':
            return (
                <>
                    <FileGifOutlined />
                    {content}
                </>
            );

        case 'pdf':
            return (
                <>
                    <FilePdfOutlined />
                    {content}
                </>
            );

        case 'doc':
        case 'docx':
            return (
                <>
                    <FileWordOutlined />
                    {content}
                </>
            );

        default:
            return (
                <>
                    <FileUnknownOutlined />
                    {content}
                </>
            );
    }
};
